/**
 *
 * Please note:
 * This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit this file manually.
 *
 */

@file:Suppress(
    "ArrayInDataClass",
    "EnumEntryName",
    "RemoveRedundantQualifierName",
    "UnusedImport"
)

package org.openapitools.client.models

import org.openapitools.client.models.NewLoop

import kotlinx.serialization.*
import kotlinx.serialization.descriptors.*
import kotlinx.serialization.encoding.*

/**
 * 
 *
 * @param title 
 * @param components 
 */
@Serializable

data class NewLoopRequest (

    @SerialName(value = "title") val title: kotlin.String? = null,

    @SerialName(value = "components") val components: kotlin.collections.List<NewLoop>? = null

)

